import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { CopyButton } from "Components/_Shared/Buttons/CopyButton";
import { HStack } from "Components/_Shared/Core/Stack";
import { FeatureFlag, getFeatureFlagKey, setFeatureFlagStored, useFeatureFlag } from "Infrastructure/Hooks/useFeatureFlag";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useSearchParams } from "react-router-dom";

type ItemProps = {
  name: string;
  flag: FeatureFlag;
};

const DevToolsFeatureFlagItem = ({ name, flag }: ItemProps) => {
  const { t } = useResource();
  const [searchParams] = useSearchParams();
  const isEnabled = useFeatureFlag(flag);
  const key = getFeatureFlagKey(flag);
  const isInUrl = searchParams.has(key);

  return (
    <HStack alignItems="center" spacing={Spacing.L}>
      <FormControlLabel
        sx={{ mr: 0, gap: Spacing.S }}
        control={<Checkbox checked={isEnabled} disabled={isInUrl} onChange={(_, checked) => setFeatureFlagStored(flag, checked)} />}
        label={
          <Stack>
            <Typography variant="body2">{name}</Typography>
            <Typography variant="caption" color="text.secondary" fontFamily="monospace">
              {key}
            </Typography>
            {isInUrl && (
              <Typography variant="caption" color="text.secondary">
                {t(Resources.DevTools.FeatureFlags.EnabledByUrl)}
              </Typography>
            )}
          </Stack>
        }
      />
      <CopyButton text={key} />
    </HStack>
  );
};

export const DevToolsFeatureFlags = () => {
  const { t } = useResource();

  return (
    <Stack spacing={Spacing.L}>
      <Typography variant="body2" color="text.secondary">
        {t(Resources.DevTools.FeatureFlags.Description)}
      </Typography>
      <Stack spacing={Spacing.L}>
        {Object.entries(FeatureFlag).map(([name, flag]) => (
          <DevToolsFeatureFlagItem key={flag} name={name} flag={flag} />
        ))}
      </Stack>
    </Stack>
  );
};
